<template>
  <div class="menu">
    <button class="btn btn-primary btn-blank btn-lg" v-on:click="buttonDemoClick">{{buttonDemo}}</button>
       
  </div>
</template>

<script>
import lstore from '../store.js'

export default {
  data () {
    return {
      buttonDemo:'-> 点击前往',
    }
  },
  methods: {
    buttonDemoClick: function () {
      window.location.href="http://www.daijiale.cn";
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color: #42b983;
  text-align: center;
  font-family:'HanHei SC', 'PingFang SC', 'Helvetica Neue', 'Helvetica', 'STHeitiSC-Light', 'Arial', sans-serif;
}

.menu{
  text-align: center;
  z-index: 2;
}

.btn-blank {
  background-color: #fff;
  border-color:#333;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// Menu.vue?e3d519c0